import React from "react";

import { Text } from "@/components/text/Text";

import { contactInfo } from "@/Constants";
import { useStyle } from "@/context/StyleContext";
import { useLanguageContext } from "@/context/LanguageContext";
import { useMediaQuery, useTheme } from "@mui/material";

const Footer: React.FC = () => {
  const { colors, theme } = useStyle();
  const { lang } = useLanguageContext();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  return (
    <footer
      id="section-footer"
      style={{
        minHeight: "300px",
        borderTop: `1px solid ${colors[theme].border}`,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
          padding: "20px",
          flexWrap: "wrap",

          gap: "20px",
        }}
      >
        <iframe
          title="High Hair Room location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1982.5603943467038!2d24.892900877620704!3d60.204557775050006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469209f02d850fc9%3A0xc693f77de505a919!2sHigh%20Hair%20Room!5e0!3m2!1sen!2sfi!4v1748252997687!5m2!1sen!2sfi"
          width="100%"
          height="250px"
          style={{
            border: 0,
            maxWidth: "300px",
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <div>
          <Text type="h3">{contactInfo.companyOfficialName}</Text>
          <Text>{contactInfo.street}</Text>
          <Text>
            {contactInfo.postalCode} {contactInfo.city}
          </Text>
          <Text>{contactInfo.country}</Text>
          <Text>
            {lang.t("landing.footer.companyNumberText")}: {contactInfo.YTunnus}
          </Text>
        </div>
        <div>
          <Text type="h3">{lang.t("landing.footer.socialMediaText")}</Text>
          <Text
            type="a"
            href={`https://instagram.com/${contactInfo.instagram}`}
            target="_blank"
          >
            Instagram: {contactInfo.instagram}
          </Text>
          <Text type="h3">{lang.t("landing.footer.contactUsText")}</Text>
          <Text
            type="a"
            href={
              isMobile
                ? `whatsapp://send?phone=${contactInfo.whatsAppNumber}`
                : `https://web.whatsapp.com/send?phone=${contactInfo.whatsAppNumber}`
            }
            target="_blank"
          >
            WhatsApp: {contactInfo.whatsAppNumber}
          </Text>
          <Text
            style={{
              maxWidth: "450px",
              overflowWrap: "break-word",
            }}
          >
            {lang.t("landing.footer.contactInstructions")}
          </Text>
        </div>
      </div>
      <div>
        <Text style={{ textAlign: "center" }}>
          © 2022 - {new Date().getFullYear()} High Hair Room Oy
        </Text>
      </div>
    </footer>
  );
};

export default Footer;
